// frontend/src/styles/GlobalStyles.js
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --app-zoom: 1; /* ThemeProvider lo actualiza al arrancar según tamaño de pantalla */
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    background-color: ${({ theme }) => theme.colors.bgPrincipal};
    color: ${({ theme }) => theme.colors.txtPrincipal};
    line-height: 1.6;
    margin: 0;
    padding: 0;
    height: calc(100vh / var(--app-zoom, 1)); /* Compensar zoom para que ocupe la pantalla completa */
    overflow: hidden; /* Sin scroll en body */
    transition: background-color 0.3s ease, color 0.3s ease;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #root {
    height: calc(100vh / var(--app-zoom, 1)); /* Compensar zoom */
    display: flex;
    flex-direction: column;
    overflow: hidden; /* Sin scroll en root */
  }

  /* En móvil Y tablet usar dvh (dynamic viewport height): descuenta la barra del
     navegador Chrome/Safari, que consume alto real y dejaba el footer sin llegar
     al fondo. El desktop (≥1025 px CSS) conserva 100vh/zoom sin cambios. El corte
     en 1024 px excluye laptops reales (≥1280 px CSS) e incluye todas las tablets. */
  @media (max-width: 1024px) {
    body {
      height: 100dvh;
    }
    #root {
      height: 100dvh;
    }
  }

  @media print {
    html {
      zoom: 1 !important;
    }

    body {
      background-color: ${({ theme }) => theme.colors.printBg} !important;
      color: ${({ theme }) => theme.colors.printText} !important;
      height: auto !important;
      min-height: auto !important;
      overflow: visible !important;
    }

    #root {
      height: auto !important;
      min-height: auto !important;
      overflow: visible !important;
      display: block !important;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${({ theme }) => theme.colors.txtPrincipal};
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    margin-bottom: ${({ theme }) => theme.spacing.md};
    text-wrap: balance;
  }

  h1 { font-size: ${({ theme }) => theme.typography.fontSize.xxl}; }
  h2 { font-size: ${({ theme }) => theme.typography.fontSize.xl}; }
  h3 { font-size: ${({ theme }) => theme.typography.fontSize.lg}; }
  h4 { font-size: ${({ theme }) => theme.typography.fontSize.md}; }
  h5 { font-size: ${({ theme }) => theme.typography.fontSize.sm}; }
  h6 { font-size: ${({ theme }) => theme.typography.fontSize.xs}; }

  p {
    margin-bottom: ${({ theme }) => theme.spacing.md};
    color: ${({ theme }) => theme.colors.txtSecondary};
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: ${({ theme }) => theme.colors.primaryHover};
    }
  }

  button {
    font-family: inherit;
  }

  input, textarea, select {
    font-family: inherit;
  }

  /* Tema del sistema para controles nativos (selector de fecha/hora del navegador,
     checkboxes, radios, spinners numéricos, etc.). Sin esto, en modo oscuro el
     calendario nativo y los controles aparecen con fondo blanco. Se aplica una sola
     vez a nivel global según el tema activo y cubre todo el sistema. */
  :root {
    color-scheme: ${({ theme }) => (theme.isDark ? 'dark' : 'light')};
  }

  input, textarea, select {
    color-scheme: ${({ theme }) => (theme.isDark ? 'dark' : 'light')};
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.scrollTrack};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.scrollThumb};
    border-radius: ${({ theme }) => theme.borderRadius.sm};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.scrollThumbHover};
  }

  /* Google Places Autocomplete dropdown — siempre por encima de modales */
  .pac-container {
    z-index: 2000 !important;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.colors.borderDefault};
    background: ${({ theme }) => theme.colors.surface};
    box-shadow: 0 4px 16px ${({ theme }) => theme.colors.shadowPaper};
    font-family: inherit;
  }
  .pac-item {
    padding: 6px 10px;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.txtPrincipal};
    border-top: 1px solid ${({ theme }) => theme.colors.borderDefault};
    cursor: pointer;
  }
  .pac-item:hover, .pac-item-selected {
    background: ${({ theme }) => theme.colors.surfaceHover};
  }
  .pac-item-query {
    color: ${({ theme }) => theme.colors.txtPrincipal};
    font-size: 13px;
  }
  .pac-matched {
    font-weight: 600;
  }

  /* Informes: Recharts agrega foco accesible a barras/sectores con onClick
     (para fijar el resaltado); sin esto el navegador dibuja un recuadro de
     foco por defecto al hacer clic, que no aporta nada visualmente acá. */
  .recharts-wrapper svg:focus,
  .recharts-wrapper svg *:focus {
    outline: none;
  }
`;

export default GlobalStyles;
